import { useCallback } from 'react';
import type { ProductOrderItem } from '../data/product-order-item';
import { allocateCasesByDOH } from '../utils/tier-allocator';
import type { Family } from './use-families';

/**
 * Returns an allocator that distributes `targetCases` across a family's
 * carried members via greedy projected-DOH (see `allocateCasesByDOH`). This
 * is the "replace" form: members filtered from allocation (zero-velocity or
 * zero case_qty) are explicitly cleared so a tier-down or frontline click
 * doesn't leave stale values.
 */
export function useTierAllocator(setOrderItem: (item: ProductOrderItem) => void) {
  return useCallback(
    (family: Family, targetCases: number) => {
      const { allocated, skipped } = allocateCasesByDOH(family.members, targetCases);
      for (const { orderItem, cases } of allocated) {
        setOrderItem({ ...orderItem, cases, units: 0 });
      }

      for (const item of skipped) {
        setOrderItem({ ...item, cases: 0, units: 0 });
      }
    },
    [setOrderItem]
  );
}
